import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { UseFormMethods } from 'react-hook-form/dist/types/form';
import { FormElement } from 'src/front/components/FormStyles';
import { TextInput } from '@code/innovance-react-ui-kit';
import { useTranslation } from 'react-i18next';
import { IdentityFormData } from 'src/front/components/identity/IdentityFormData';

interface Props {
  formatter: (v: string) => string;
  formMethods: UseFormMethods<IdentityFormData>;
  mask?: string;
  max: number;
  min: number;
  onChangeHandler: (field: string, mask?: string) => (value: string) => void;
}
const DocumentNumber: FC<Props> = ({ formatter, formMethods, mask, max, min, onChangeHandler }) => {
  const { control, errors } = formMethods;
  const { t } = useTranslation();

  return (
    <FormElement>
      <Controller
        control={control}
        name="identityDocumentSerialNumber"
        render={({ onChange, value }) => (
          <TextInput
            errorMessage={t(errors?.identityDocumentSerialNumber?.message as string, { min })}
            formatter={formatter}
            label={t('general_documentNumber_label')}
            maxLength={max}
            name="identityDocumentSerialNumber"
            onChange={(val) => {
              onChange(val);
              onChangeHandler('identityDocumentSerialNumber', mask)(val);
            }}
            value={value}
            required
          />
        )}
      />
    </FormElement>
  );
};

export default DocumentNumber;
